var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90451 12.0079C2.73365 11.828 2.73365 11.6032 2.90451 11.4233L13.5829 0.134921C13.7538 -0.0449735 13.9673 -0.0449735 14.1382 0.134921C14.309 0.314815 14.309 0.539683 14.1382 0.719577L3.45978 12.0079C3.28893 12.1878 3.03265 12.1878 2.90451 12.0079Z",
    fill: "#E63335",
    fillOpacity: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7437 5.75659C13.7538 2.5185 10.6784 1.03437 7.60301 1.25924C3.07538 1.61903 0.298995 5.62167 0.170854 5.80157L0 6.07141L0.170854 6.34125C0.341709 6.52114 3.41709 10.7487 8.11558 10.9735C8.24372 10.9735 8.37186 10.9735 8.45729 10.9735C11.3191 10.9735 14.0955 9.44442 16.7437 6.38622L17 6.07141L16.7437 5.75659ZM8.15829 10.0741C4.52764 9.89416 1.83668 6.97088 1.11055 6.07141C1.79397 5.17194 4.22864 2.42855 7.68844 2.15871C10.3794 1.93384 13.1558 3.28305 15.8467 6.07141C13.3693 8.81479 10.7638 10.164 8.15829 10.0741Z",
    fill: "#E63335",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80957 6.07132C5.80957 7.60042 7.00555 8.85968 8.45781 8.85968C9.91007 8.85968 11.1061 7.60042 11.1061 6.07132C11.1061 4.54222 9.91007 3.28296 8.45781 3.28296C7.00555 3.28296 5.80957 4.54222 5.80957 6.07132ZM8.45781 4.00254C9.56836 4.00254 10.4226 4.94698 10.4226 6.07132C10.4226 7.19566 9.52565 8.1401 8.45781 8.1401C7.38997 8.1401 6.49299 7.19566 6.49299 6.07132C6.49299 4.94698 7.38997 4.00254 8.45781 4.00254Z",
    fill: "#E63335",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/HidePassword.d83e790faa6dd248e8a88f7e7506e9af.svg";
export { ForwardRef as ReactComponent };